<template>
  <div class="error-container">
    <!-- 背景图模糊层 -->
    <div class="bg-layer"></div>

    <!-- 错误卡片 -->
    <div class="error-card">
      <!-- 返回按钮 -->
      <button type="button" class="back-btn" @click="handleBack">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path
            d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
            fill="currentColor"
          />
        </svg>
        返回首页
      </button>

      <!-- 错误图标 -->
      <div class="error-icon">
        <svg viewBox="0 0 24 24" width="80" height="80">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            fill="currentColor"
          />
        </svg>
      </div>

      <!-- 错误信息 -->
      <div class="error-content">
        <h1 class="error-code">{{ errorCode }}</h1>
        <h2 class="error-title">{{ errorTitle }}</h2>
        <p class="error-desc">{{ errorDesc }}</p>
      </div>

      <!-- 操作按钮 -->
      <div class="error-actions">
        <button class="action-btn primary" @click="handleRefresh">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
              fill="currentColor"
            />
          </svg>
          刷新重试
        </button>
        <button class="action-btn secondary" @click="handleBack">
          返回首页
        </button>
      </div>

      <!-- 底部提示 -->
      <div class="error-footer">
        <p>如果问题持续存在，请联系技术支持</p>
        <a href="#" class="contact-link" @click.prevent="handleContact">
          support@example.com
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    code: {
      type: [String, Number],
      default: 404,
    },
    title: {
      type: String,
      default: "页面未找到",
    },
    desc: {
      type: String,
      default: "您访问的页面不存在或已被移除",
    },
  },
  data() {
    return {
      errorCode: this.code,
      errorTitle: this.title,
      errorDesc: this.desc,
    };
  },
  methods: {
    handleBack() {
      this.$router.push({ name: "Login" });
    },
    handleRefresh() {
      window.location.reload();
    },
    handleContact() {
      console.log("联系技术支持");
      // 可以打开邮件客户端或跳转到联系页面
      window.location.href = "mailto:support@example.com";
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.error-container {
  position: relative;
  /* width: 100%; */
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
}

/* ===== 背景图层 ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 错误卡片 ===== */
.error-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  padding: 48px 44px 40px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.error-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 返回按钮 ===== */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 20px;
}

.back-btn:hover {
  color: #00b4ff;
  transform: translateX(-4px);
}

/* ===== 错误图标 ===== */
.error-icon {
  margin: 12px 0 20px;
  color: rgba(255, 180, 0, 0.3);
}

.error-icon svg {
  animation: pulse-icon 2s ease-in-out infinite;
}

@keyframes pulse-icon {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}

/* ===== 错误信息 ===== */
.error-content {
  margin-bottom: 32px;
}

.error-code {
  font-size: 72px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.08);
  letter-spacing: 4px;
  margin: 0 0 4px;
  line-height: 1;
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

.error-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  letter-spacing: 1px;
}

.error-desc {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
  line-height: 1.6;
}

/* ===== 操作按钮 ===== */
.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 28px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.action-btn.primary {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.35);
}

.action-btn.primary:active {
  transform: translateY(0);
}

.action-btn.secondary {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.action-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  transform: translateY(-2px);
}

.action-btn.secondary:active {
  transform: translateY(0);
}

/* ===== 底部 ===== */
.error-footer {
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.error-footer p {
  color: rgba(255, 255, 255, 0.3);
  font-size: 13px;
  margin: 0 0 4px;
}

.contact-link {
  color: #00b4ff;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #66ccff;
  text-decoration: underline;
}

/* ===== 响应式适配 ===== */
@media (max-width: 520px) {
  .error-card {
    padding: 32px 24px 28px;
    border-radius: 16px;
    margin: 12px;
  }

  .error-code {
    font-size: 56px;
  }

  .error-title {
    font-size: 20px;
  }

  .error-desc {
    font-size: 13px;
  }

  .error-icon svg {
    width: 60px;
    height: 60px;
  }

  .error-actions {
    flex-direction: column;
    gap: 10px;
  }

  .action-btn {
    justify-content: center;
    padding: 11px 20px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }
}

@media (max-width: 380px) {
  .error-card {
    padding: 24px 16px 20px;
  }

  .error-code {
    font-size: 44px;
  }

  .error-title {
    font-size: 18px;
  }

  .error-icon svg {
    width: 48px;
    height: 48px;
  }

  .action-btn {
    font-size: 13px;
    padding: 9px 16px;
  }
}
</style>